module.exports = __webpack_public_path__ + "img/8.f80b3230.svg";